export default "__VITE_ASSET__b0d2bdf1__"